import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthenticationService } from './authentication.service';
import {ClientRequest} from  '../../ClientRequest';


@Injectable()
export class ApiService {
    constructor( private clientRequest: ClientRequest) {};
    
    getConfig():Observable<any> {
        return this.clientRequest.get('/config').map((response: HttpResponse<any>) => {
                return response;
            });
    };
    findForm(id): Observable<any> {
        return this.clientRequest.get('/form/' + id).map((response: HttpResponse<any>) => {
                return response;
            });
    };
    submitForm(id,data): Observable<any> {
        return this.clientRequest.post('/form/' + id + '/submit',data).map((response: HttpResponse<any>) => {
                return response;
            });
    };
    submitComment(model): Observable<any> {
        return this.clientRequest.post('/post/comment/'+model.id,model).map((response: HttpResponse<any>) => {
                return response;
            });
    };
    getComment(id): Observable<any> {
        return this.clientRequest.get('/post/comment/'+id+'/get').map((response: HttpResponse<any>) => {
                return response;
            });
    };
    findSlickSlider(name: string): Observable<any>{
        return this.clientRequest.get('/slide/'+name)
            .map((response: HttpResponse<any>) => {
                return response;
            });
    }
    getSlider(name: string): Observable<any>{
        return this.clientRequest.get('/slide/'+name).map((response: HttpResponse<any>) => {
            return response;
        });
    }
    homePageMeta(): Observable<any>{
        return this.clientRequest.get('/home/meta').map((response: HttpResponse<any>) => {
            return response;
        });
    }
    findMenu(name): Observable<any> {
        return this.clientRequest.get('/menu/' + name).map((response: HttpResponse<any>) => {
                return response;
            });
    };
    getPosts(total): Observable<any> {
        return this.clientRequest.get('/posts?total='+total).map((response: HttpResponse<any>) => {
           return response;
        });
    };
    
}